import {
  Alarm,
  AttachMoney,
  CheckCircle,
  CreditScore,
  InfoOutlined,
  InsertInvitation,
  Receipt,
} from "@mui/icons-material";
import {
  Box,
  Divider,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React from "react";
import { useParams } from "react-router-dom";
import DelendCentralizedCircularProgress from "../../../components/CircularProgress/DelendCentralizedCircularProgress";
import CashAdvanceService from "../../../services/CashAdvanceService";
import { dateFormatter, formatMoney } from "../../../services/UtilsService";

const styles = {
  paperWithGradientBorder: {
    background:
      "linear-gradient(white, white) padding-box, linear-gradient(180deg, rgba(80, 61, 252, 0.3) 0%, rgba(130, 10, 209, 0.3) 100%); border-box",
    borderRadius: "8px",
    border: "8px solid transparent",
  },
  paperHeader: {
    borderBottom: "1px solid #E9EBF0",
    padding: 20,
  },
  infoContainer: {
    padding: "12px 20px",
  },
};

const ViewAnticipationHeader = (props) => {
  return (
    <Box display={"flex"}>
      <Box>
        <Typography
          sx={{
            fontWeight: 400,
            fontSize: 24,
          }}
          color="inherit"
          noWrap
        >
          Detalhes do contrato
        </Typography>
        <Typography
          sx={{
            fontWeight: 400,
            fontSize: 16,
            color: "#8087A6",
          }}
          color="inherit"
          noWrap
        >
          Contrato {props.contract}
        </Typography>
      </Box>
      <Box
        sx={{
          flexGrow: 1,
        }}
      />
    </Box>
  );
};

const ContractInfos = ({ anticipation }) => {
  return (
    <Paper variant="outlined" sx={styles.paperWithGradientBorder}>
      <Grid container>
        <Grid style={styles.paperHeader} xs={12} item>
          <span
            style={{
              color: "#820AD1",
            }}
          >
            •
          </span>{" "}
          Dados do contrato
        </Grid>
        <Grid style={styles.infoContainer} container xs={12} item>
          <Grid xs={6} item>
            <Typography
              sx={{
                fontWeight: 400,
                color: "#8087A6",
              }}
              color="inherit"
              noWrap
            >
              Valor total aprovado
            </Typography>
          </Grid>
          <Grid xs={6} item>
            <Typography
              align="right"
              sx={{
                fontWeight: 400,
                color: "#00010C",
              }}
              color="inherit"
              noWrap
            >
              {formatMoney(anticipation.contractTerms.grossAmount)}
            </Typography>
          </Grid>
        </Grid>
        <Grid style={styles.infoContainer} container xs={12} item>
          <Grid xs={6} item>
            <Typography
              sx={{
                fontWeight: 400,
                color: "#8087A6",
              }}
              color="inherit"
              noWrap
            >
              (-) Juros de antecipação
            </Typography>
          </Grid>
          <Grid xs={6} item>
            <Typography
              align="right"
              sx={{
                fontWeight: 400,
                color: "#00010C",
              }}
              color="inherit"
              noWrap
            >
              {formatMoney(anticipation.contractTerms.feeAmount)}
            </Typography>
          </Grid>
        </Grid>
        <Grid style={styles.infoContainer} container xs={12} item>
          <Grid xs={6} item>
            <Typography
              sx={{
                fontWeight: 400,
                color: "#8087A6",
              }}
              color="inherit"
              noWrap
            >
              (-) IOF
            </Typography>
          </Grid>
          <Grid xs={6} item>
            <Typography
              align="right"
              sx={{
                fontWeight: 400,
                color: "#00010C",
              }}
              color="inherit"
              noWrap
            >
              {formatMoney(anticipation.contractTerms.iof)}
            </Typography>
          </Grid>
        </Grid>
        <Grid style={styles.infoContainer} container xs={12} item>
          <Grid xs={6} item>
            <Typography
              sx={{
                fontWeight: 400,
                color: "#8087A6",
              }}
              color="inherit"
              noWrap
            >
              (-) TAC
            </Typography>
          </Grid>
          <Grid xs={6} item>
            <Typography
              align="right"
              sx={{
                fontWeight: 400,
                color: "#00010C",
              }}
              color="inherit"
              noWrap
            >
              {formatMoney(anticipation.contractTerms.tac)}
            </Typography>
          </Grid>
        </Grid>
        <Grid style={styles.infoContainer} container xs={12} item>
          <Grid xs={6} item>
            <Box display={"flex"}>
              <CheckCircle
                sx={{
                  color: "#269800",
                }}
              />
              <Typography
                ml={"12px"}
                sx={{
                  fontWeight: 400,
                  color: "#269800",
                }}
                color="inherit"
              >
                Valor líquido
              </Typography>
            </Box>
          </Grid>
          <Grid xs={6} item>
            <Typography
              align="right"
              sx={{
                fontWeight: 600,
                color: "#269800",
              }}
              color="inherit"
              noWrap
            >
              {formatMoney(anticipation.contractTerms.totalCreditAmount)}
            </Typography>
          </Grid>
        </Grid>
        {/* <Grid style={styles.infoContainer} container xs={12} item>
          <Grid xs={6} item>
            <Typography
              sx={{
                ml: "8px",
                fontWeight: 400,
                fontSize: "14px",
                color: "#00010C",
              }}
              noWrap
            >
              {`Taxa de juros (%a.m) - ${anticipation.contractTerms.taxMonthPercent}%`}
            </Typography>
          </Grid>
          <Grid xs={6} item>
            <Typography
              align="right"
              sx={{
                ml: "8px",
                fontWeight: 400,
                fontSize: "14px",
                color: "#00010C",
              }}
              noWrap
            >
              {`CET (%a.a) - ${anticipation.contractTerms.cetPercent}%`}
            </Typography>
          </Grid>
        </Grid> */}
      </Grid>
    </Paper>
  );
};

const DepositInfos = ({ anticipation }) => {
  const statusDescription = {
    IN_PROGRESS: "Em andamento",
    PAID: "Pago"
  };

  return (
    <Box sx={styles.paperWithGradientBorder} height={"100%"}>
      {/* <Grid container> */}
      <Grid style={styles.paperHeader} xs={12} item>
        <span
          style={{
            color: "#820AD1",
          }}
        >
          •
        </span>{" "}
        Dados do depósito
      </Grid>

      <Box display={"flex"} padding={{ padding: "16px" }}>
        <Box>
          <CreditScore
            sx={{ color: "#A10165", paddingRight: "4px" }}
            fontSize="small"
          />
        </Box>
        <Box>
          Intituição financeira, agência e conta
          <Box display={"flex"}>
            <Box margin={"8px 0px"}>
              <Typography
                align="right"
                sx={{
                  fontWeight: 400,
                  fontSize: "14px",
                  color: "#00010C",
                }}
              >
                <img
                  alt="logo"
                  width={"24px"}
                  style={{ marginRight: "8px" }}
                  src={anticipation.deposit?.bankAccountDestination?.logoUrl}
                />
                {anticipation.deposit?.bankAccountDestination?.name}
              </Typography>

              <Typography
                align="right"
                sx={{
                  fontWeight: 400,
                  fontSize: "14px",
                  color: "#8087A6",
                }}
                noWrap
              >
                {anticipation.deposit?.bankAccountDestination?.code}
              </Typography>
            </Box>

            <Box display={"flex"} margin={"8px 16px"}>
              <Divider orientation="vertical" variant="middle" flexItem />
            </Box>

            <Box margin={"8px 0px"}>
              <Typography
                sx={{
                  fontWeight: 400,
                  fontSize: "14px",
                  color: "#00010C",
                }}
                noWrap
              >
                {`Ag. ${anticipation.deposit?.bankAccountDestination?.agency}`}
              </Typography>
              <Typography
                sx={{
                  fontWeight: 400,
                  fontSize: "14px",
                  color: "#00010C",
                }}
                noWrap
              >
                {`C/C. ${anticipation.deposit?.bankAccountDestination?.accountNumber}`}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>

      <Grid container xs={12} item sx={{ padding: "16px" }} spacing={2}>
        <Grid container xs={12} item>
          <Grid item xs={6}>
            <Typography
              sx={{
                fontWeight: 400,
                fontSize: "14px",
                color: "#575757",
              }}
              noWrap
            >
              <InsertInvitation
                sx={{ color: "#E71D36", paddingRight: "4px" }}
                fontSize="small"
              />
              Data do Pagamento
            </Typography>
            <Typography
              align="left"
              sx={{
                ml: "20px",
                mt: "8px",
                fontWeight: 400,
                fontSize: "14px",
                color: "#00010C",
              }}
              noWrap
            >
              {dateFormatter(anticipation.deposit.expectedPaymentDate)}
            </Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography
              sx={{
                ml: "8px",
                fontWeight: 400,
                fontSize: "14px",
                color: "#575757",
              }}
              noWrap
            >
              <InfoOutlined
                sx={{ color: "#FF8500", paddingRight: "4px" }}
                fontSize="small"
              />{" "}
              Situação do Pagamento
            </Typography>
            <Typography
              align="left"
              sx={{
                ml: "32px",
                mt: "8px",
                fontWeight: 400,
                fontSize: "14px",
                color: "#00010C",
              }}
              noWrap
            >
              {anticipation.deposit &&
                statusDescription[anticipation.deposit?.depositStatus]}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      {/* </Grid> */}
    </Box>
  );
};

const InvoiceInformation = (props) => {
  const statusIcon = {
    PAID: <AttachMoney sx={{ color: "#269800" }} />,
    PENDING: <Alarm sx={{ color: "#FF8500" }} />,
  };

  const statusLabel = {
    PAID: "Quitado",
    PENDING: "Pendente",
  };
  const anticipation = props.anticipation;
  const headCells = [
    {
      id: "billNumber",
      numeric: false,
      disablePadding: false,
      label: "Número da parcela",
    },
    {
      id: "totalValue",
      numeric: false,
      disablePadding: false,
      label: "Valor da parcela",
    },
    {
      id: "deadline",
      numeric: false,
      disablePadding: false,
      label: "Data do vencimento",
    },
    {
      id: "payDay",
      numeric: false,
      disablePadding: false,
      label: "Data do pagamento",
    },
    {
      id: "status",
      numeric: false,
      disablePadding: false,
      label: "Situação",
    },
    {
      id: "download",
      numeric: false,
      disablePadding: false,
      label: "Boleto",
    },
  ];

  const downloadBoleto = async (path) => {
    const boleto = await CashAdvanceService.downloadBoleto(path)

    let binaryString = window.atob(boleto.data);

    let binaryLen = binaryString.length;

    let bytes = new Uint8Array(binaryLen);

    for (let i = 0; i < binaryLen; i++) {
      let ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }

    let blob = new Blob([bytes], {type: "application/pdf"});

    let link = document.createElement('a');

    link.href = window.URL.createObjectURL(blob);
    link.download = path;

    link.click();

  }


  return (
    <Paper variant="outlined" sx={styles.paperWithGradientBorder}>
      <Grid container>
        <Grid style={styles.paperHeader} xs={12} item>
          <span style={{ color: "#820AD1" }}>•</span> Dados da cobrança
        </Grid>
      </Grid>
      <TableContainer>
        <Table aria-labelledby="tableTitle">
          <TableHead>
            {headCells.map((headCell) => (
              <TableCell
                sx={{ borderRight: "1px solid #E9EBF0", color: "#575757" }}
                key={headCell.id}
                align={headCell.numeric ? "right" : "left"}
                padding={headCell.disablePadding ? "none" : "normal"}
              >
                {headCell.label}
              </TableCell>
            ))}
          </TableHead>
          <TableBody>
            {anticipation?.charges?.map((row, index) => {
              const labelId = `enhanced-table-checkbox-${index}`;

              return (
                <TableRow key={row.contractNumber}>
                  <TableCell component="th" id={labelId} scope="left">
                    {row.installmentNumber}
                  </TableCell>
                  <TableCell component="th" id={labelId} scope="left">
                    {formatMoney(row.amount)}
                  </TableCell>
                  <TableCell align="left">
                    {dateFormatter(row.dueDate)}
                  </TableCell>
                  <TableCell align="left">
                    {row.paidAt != null
                      ? dateFormatter(row.paidAt)
                      : "Em aberto"}
                  </TableCell>
                  <TableCell align="left">
                    {statusIcon[row.status]} {statusLabel[row.status]}
                  </TableCell>
                  <TableCell align="left">
                    <IconButton onClick={() => downloadBoleto(row.printUrl)}>
                      <Receipt  sx={'color: #666'}/>
                    </IconButton>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

const AnticipatedReceivableInfos = (props) => {
  const anticipation = props.anticipation;
  const headCells = [
    {
      id: "nfNumber",
      numeric: false,
      disablePadding: false,
      label: "Número da nota fiscal • Série",
    },
    {
      id: "issueAt",
      numeric: false,
      disablePadding: false,
      label: "Emissão",
    },
    {
      id: "name",
      numeric: false,
      disablePadding: false,
      label: "Razão social",
    },

    {
      id: "amountAndStatus",
      numeric: false,
      disablePadding: false,
      label: "Valor da nota • Condições de pagamento ",
    },
  ];
  return (
    <Paper variant="outlined" sx={styles.paperWithGradientBorder}>
      <Grid container>
        <Grid style={styles.paperHeader} xs={12} item>
          <span style={{ color: "#820AD1" }}>•</span> Recebíveis antecipados
        </Grid>
      </Grid>
      <TableContainer>
        <Table aria-labelledby="tableTitle">
          <TableHead sx={{}}>
            {headCells.map((headCell) => (
              <TableCell
                sx={{ borderRight: "1px solid #E9EBF0", color: "#575757" }}
                key={headCell.id}
                align={headCell.numeric ? "right" : "left"}
                padding={headCell.disablePadding ? "none" : "normal"}
              >
                {headCell.label}
              </TableCell>
            ))}
          </TableHead>
          <TableBody>
            {anticipation?.receivables?.map((row, index) => {
              const labelId = `enhanced-table-checkbox-${index}`;

              return (
                <TableRow key={row.id}>
                  <TableCell component="th" id={labelId} scope="left">
                    {`${row.notaFiscal.number}-${row.notaFiscal.serie}`}
                  </TableCell>
                  <TableCell align="left">
                    {dateFormatter(row.notaFiscal.issuedAt)}
                  </TableCell>
                  <TableCell align="left">
                    {row.notaFiscal.tomador.name}
                  </TableCell>
                  <TableCell align="left">
                    {`${formatMoney(row.notaFiscal.totalAmount)} em ${
                      row.notaFiscal.bill.numberOfInstallments
                    }x de ${formatMoney(
                      row.notaFiscal.bill.installmentAverageAmount
                    )}`}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

const ViewAnticipation = () => {
  let { uuid } = useParams();
  const [loading, setLoading] = React.useState(true);
  const [anticipation, setAnticipation] = React.useState(true);

  React.useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const response = await CashAdvanceService.getCashAdvance(uuid);
      setLoading(false);
      if (response.data) setAnticipation(response.data);
    };

    fetchData();
  }, [uuid]);

  return loading ? (
    <DelendCentralizedCircularProgress />
  ) : (
    <Box
      sx={{
        margin: 1,
      }}
    >
      <ViewAnticipationHeader contract={anticipation.contractNumber} />

      <Box sx={{ padding: 0, borderRadius: "8px", marginTop: "32px" }}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <ContractInfos anticipation={anticipation} />
          </Grid>
          <Grid item xs={6}>
            <DepositInfos anticipation={anticipation} />
          </Grid>
          <Grid item xs={12}>
            <InvoiceInformation anticipation={anticipation} />
          </Grid>
          <Grid item xs={12}>
            <AnticipatedReceivableInfos anticipation={anticipation} />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default ViewAnticipation;
